import { HttpParams, HttpParamsOptions } from '@angular/common/http';
import { pickBy } from 'lodash-es';
import { Maybe, getIsNotNullable } from '../../nullable-utils';

/**
 * Creates an instance of HttpParams that does not contain nullable values.
 *
 * @param queryParams the object that contains the query params
 * @returns the instance of HttpParams, pruned of all nullables
 */
export function safelyCreateHttpParams<T extends HttpParamsOptions['fromObject']>(
  queryParams: T,
): HttpParams {
  return new HttpParams({ fromObject: pickBy(queryParams, getIsNotNullableNorNaN) });
}

function getIsNotNullableNorNaN<T>(value: Maybe<T>): value is T {
  return getIsNotNullable(value) && !(typeof value === 'number' && isNaN(value as number));
}
